import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-warning-banner',
    templateUrl: './warning-banner.component.html',
    styleUrls: ['./warning-banner.component.scss'],
    standalone: false
})
export class WarningBannerComponent implements OnInit {
  @Input() message?: string;
  @Input() showCloseButton: boolean = true;

  defaultMessage: string = "This page is set to be removed November 2024, please use the Service Insights tab and Excel Download for this data.";
  isDismissed: boolean = false;
  private readonly BASE_STORAGE_KEY = 'warningBannerDismissed';

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Check sessionStorage when component initializes
    this.isDismissed = sessionStorage.getItem(this.storageKey) === 'true';
  }

  private get storageKey(): string {
    // Create a unique key for each route
    return `${this.BASE_STORAGE_KEY}_${this.router.url.replace(/\//g, '_')}`;
  }

  dismissBanner() {
    this.isDismissed = true;
    // Save the dismissed state to sessionStorage with the route-specific key
    sessionStorage.setItem(this.storageKey, 'true');
  }
}
